import { createTheme } from "@mui/material/styles";

export const createShieldShotTheme = (mode = "light") =>
  createTheme({
    palette: {
      mode,
      primary: { main: "#2997ff" },
      secondary: { main: "#5e9fff" },
      background:
        mode === "dark"
          ? { default: "#0f172a", paper: "#111827" }
          : { default: "#f8f9fa", paper: "#ffffff" },
      text:
        mode === "dark"
          ? { primary: "#e5e7eb", secondary: "#94a3b8" }
          : { primary: "rgba(0,0,0,0.87)", secondary: "rgba(0,0,0,0.6)" },
      divider:
        mode === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)",
      action:
        mode === "dark"
          ? {
              hover: "rgba(255,255,255,0.08)",
              selected: "rgba(255,255,255,0.16)",
            }
          : {},
    },
    typography: {
      fontFamily: "Jost, Arial, Helvetica, sans-serif",
      h1: { fontWeight: 600 },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 500 },
      h5: { fontWeight: 500 },
      h6: { fontWeight: 500 },
      button: { fontWeight: 500, textTransform: "none" },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            colorScheme: mode,
            backgroundColor: mode === "dark" ? "#0f172a" : "#f8f9fa",
            margin: 0,
            padding: 0,
          },
          body: {
            backgroundColor: mode === "dark" ? "#0f172a" : "#f8f9fa",
            margin: 0,
            padding: 0,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "30px",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              transform: "translateY(-1px)",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            },
          },
          containedPrimary: {
            background: "linear-gradient(135deg, #2997ff 0%, #5e9fff 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #1d7ce6 0%, #4a8cff 100%)",
            },
          },
          outlinedPrimary: {
            border: "2px solid #2997ff",
            color: "#2997ff",
            "&:hover": {
              background: "#2997ff",
              borderColor: "#2997ff",
              color: "#ffffff",
            },
          },
        },
      },
    },
  });

// Backwards-compatible default export: light theme.
// App.jsx no longer uses this directly; it goes through ThemeModeProvider.
export default createShieldShotTheme("light");
